import { VictimTag } from '../types/victimTypes'

export const COPY = {
  INTRO_1: 'In Trolley lopolis... WE TAKE NO PRISONERS! You are a big,',
  INTRO_2:
    'bumbling, rumbling choo choo chonker Trolley. Time to decide who lives and who dies!',
  WHO_LIVES_QUESTION:
    'who WILL YOU CHUGGGA CHUGGA CHOOSE?! Will you veer Left or Right?',
  COW_ON_TV:
    "That's Heifferopolis. She's got her own game on the Houseboat launcher.",
  START_WEB: 'Click the trolley to start',
  START_TV: 'PRESS OK to start',
  SKIP_HINT: 'OK ▸ skip',
  RUN_THEM_OVER: 'PRESS OK to run them over',
  PLAY_AGAIN: 'PLAY AGAIN',
  COPY_VERDICT: 'Copy my verdict',
  COPIED: 'Copied!',
}

/** "your first ever pet" → "Your first ever pet" for sentence starts. */
export const victimLabel = (name: string): string =>
  name.charAt(0).toUpperCase() + name.slice(1)

const SMALL_NUMBERS = [
  'Zero',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
  'Ten',
  'Eleven',
  'Twelve',
]

export const numberWord = (n: number): string =>
  n >= 0 && n < SMALL_NUMBERS.length ? SMALL_NUMBERS[n] : String(n)

/** Plural nouns for the tally lines: "you spare animals and murder food". */
export const TAG_NOUN: Record<VictimTag, string> = {
  animal: 'animals',
  human: 'people',
  food: 'food',
  'loved-one': 'your loved ones',
  object: 'inanimate objects',
  pop: 'celebrities',
}

export const DYNAMIC_COPY = {
  LEFT_VICTIM_INTRO: (victimName: string) =>
    `If you veer to the left, you kill ${victimName}.`,
  RIGHT_VICTIM_INTRO: (victimName: string) =>
    `Veer to the right, you kill ${victimName}.`,
  KILLED_NUMBER: (victimName: string, numTimesKilled: string) =>
    `You were the ${numTimesKilled} bastard to murder ${victimName}.`,
  KILLED_PERCENT: (victimName: string, percentTimesKilled: string) =>
    `${victimLabel(victimName)} gets killed ${percentTimesKilled} percent of the time.`,
  /** "Five down. You spare animals and murder your loved ones. You have a type." */
  TYPE_LINE: (bodyCount: number, sparedNoun: string, killedNoun: string) =>
    `${numberWord(bodyCount)} down. You spare ${sparedNoun} and murder ${killedNoun}. You have a type.`,
  NO_TYPE_LINE: (bodyCount: number) =>
    `${numberWord(bodyCount)} down. No pattern yet. Just carnage.`,
  BODY_COUNT: (bodyCount: number, runLength: number) =>
    `BODY COUNT ${bodyCount} / ${runLength}`,
  LOVED_ONE_STREAK: (streak: number) => `${streak} loved ones in a row`,
  SPARED_BY_MOST: (n: number) =>
    n === 1
      ? 'You killed 1 victim most people spare.'
      : `You killed ${n} victims most people spare.`,
  WORST_MOMENT: (victimName: string, percent: number) =>
    `Worst moment: ${victimName} (${percent}% of people do that)`,
  FAVORITE_PREY: (noun: string, count: number) =>
    `Favorite prey: ${noun} (${count})`,
  LAST_RUN: (lastGrade: string, bestGrade: string) =>
    lastGrade === bestGrade
      ? `Last run: ${lastGrade}`
      : `Last run: ${lastGrade} · Best: ${bestGrade}`,
}

/**
 * Reaction to the kill rate, keyed by how the crowd voted. Appended to the
 * percent line so the number itself becomes a joke about the player.
 */
export const KILL_RATE_REACTION = {
  rare: [
    `You monster.`,
    `Almost nobody does that. You did.`,
    `The trolley is impressed. The trolley is the only one.`,
  ],
  unusual: [
    `Bold choice.`,
    `A minority opinion, and a loud one.`,
    `The jury is out. The jury is mostly against you.`,
  ],
  coinFlip: [
    `Coin flip. Cold.`,
    `Fifty fifty, and you picked the trolley.`,
    `Could have gone either way. You made sure.`,
  ],
  popular: [
    `Popular choice. Doesn't make it right.`,
    `You and most of the internet.`,
    `Crowd favorite. The crowd should be ashamed.`,
  ],
  everyone: [
    `Everybody does. You're not special.`,
    `Nobody's losing sleep over that one.`,
    `Join the club. The club is enormous.`,
  ],
}

export const reactionBand = (
  percent: number,
): keyof typeof KILL_RATE_REACTION => {
  if (percent < 15) return 'rare'
  if (percent < 40) return 'unusual'
  if (percent <= 60) return 'coinFlip'
  if (percent <= 85) return 'popular'
  return 'everyone'
}

/** End-of-run grade commentary, S (saintly) through F. */
export const GRADE_ZINGER: Record<string, string> = {
  S: 'Spotless. You only killed what everyone kills. The trolley is bored.',
  A: 'Mostly defensible. Mostly.',
  B: 'A few questionable calls. Nothing a good lawyer could not fix.',
  C: 'Medium ethics. Medium trolley. Medium everything.',
  D: 'That was a lot of innocent blood for one sitting.',
  F: 'Seek help. Or a second run. The trolley recommends the second run.',
}

export const COPY_VARIATION = {
  ROLLING_AGAIN: [
    `Oh no the trolley won't stop!`,
    `Trolley by trolley they fall...`,
    `THE TROLLEY BARELY SLOWED!`,
    `Good God, wait what's that up ahead?`,
    `Like sand through an hourglass, so are our lives.`,
    `This trolley of the damned keeps chugging!`,
    `Looks like the brakes took a permanent vacation!`,
    `If you see your life flashing before your eyes, it's just the reflection off the shiny front of the trolley.`,
    `It's a bird, it's a plane, nope, it's a dang trolley.`,
    `If you can't stand the heat, get off the tracks!`,
    `Roses are red, violets are blue, this trolley outta control, and comin right at you!`,
    `You shoulda taken the bus today!`,
    `The trolley may be outta control, but at least it's on schedule- next arrival RIGHT NOW!`,
    `If you got a God it's praying time!`,
    `You'd better finish up your deal with the Devil cause the trolley's a comin fast!`,
    `chugga CHUGGA chugga CHUGGA oh FUDGE--!`,
  ],
}

export const DYNAMIC_COPY_VARIATION = {
  SENTENCE_VICTIM: (victimName: string) => [
    `Ya hear that, ${victimName}? God said TIME TO DIE!`,
    `${victimName} you've been sentenced TO DEATH!`,
    `Sorry, ${victimName}, you're taking the TROLLEY TO HELL!`,
    `Woh, ${victimName}! Watch out for that-!`,
    `From on high its time to die ${victimName}!`,
    `Satan's got ya ankles, ${victimName}! And he's gonna twist them!`,
    `The countdown to your demise has officially begun, ${victimName}. Tick tock...`,
    `Pack your bags, ${victimName}, you're heading to the afterlife!`,
    `I hope you made peace with your maker, ${victimName}, because you're about to meet them!`,
    `The end is near, ${victimName}. Can you feel it?`,
    `I hope you lived a good life, ${victimName}, because this is the end of the road!`,
    `Don't be afraid, ${victimName}, death is just a part of life. Embrace it.`,
    `You can run, ${victimName}, but you can't run faster than the trolley!`,
    `Time to pay the piper, ${victimName}!`,
    `Don't worry, ${victimName}, death is painless... BUT TROLLEYS AIN'T!`,
    `It's a sad day for you, ${victimName} but a good day for the TROLLEY OF DOOM!`,
    `The bell tolls for thee, ${victimName}!`,
  ],
}
